import React, { useState, useEffect } from 'react';
import 'antd/dist/antd.css';
import styles from './Applications.module.css';
import { Row, Col, Card, Space, Spin, Input, Button, Table, Modal, Tooltip, Typography } from 'antd';
import { InfoCircleOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import { fetchUserVal, fetchJsData } from '../../../../api';
const { Text } = Typography;

// Modal Popup Window
export const OpenMod = (props) => {
    const [app, setApp] = useState(props.app);
    const [load, setLoad] = useState(true);
    const [usrRel, setUsrRel] = useState(props.usrRel);
    const [rel, setRel] = useState(props.rel);
    const [modData, setModData] = useState({
        conActName: 'conAct',
        conAct: '',
        conActDom: '',
        conAppPrior: '',
        conDlpSup: '',
    });
    const [comp, setComp] = useState(false);
    const [showAct1, setShowAct1] = useState(false);
    const [showAct2, setShowAct2] = useState(false);
    const [showDom1, setShowDom1] = useState(false);
    const [showDom2, setShowDom2] = useState(false);
    const [actActionModal, setActActionModal] = useState(false);
    const [selAct, setSelAct] = useState('');
    const [show, setShow] = useState(false);
    const openModal = () => setShow(props.openModal);
    const closeModal = () => {
        setShow(false);
        setComp(false);
        setSelAct('');
        setActActionModal(false);
    };
    const prevRel = rel - 1;
    const ppRel = rel - 2;
    const [compData, setCompData] = useState([
        {
            release: '',
            actName: '',
            domain: '',
        },
    ]);
    const [compDomData, setCompDomData] = useState([]);
    const [compAddnData, setCompAddnData] = useState([
        {
            release: '',
        },
    ]);

    // initial effect
    useEffect(() => {
        setApp(props.app);
        if (props.openModal === true) {
            openModal();
            fetchData();
            setCompData([
                {
                    release: '',
                    actName: '',
                    domain: '',
                },
            ]);
        }
    }, [props.app, props.trig]);

    // Compare effect
    useEffect(() => {
        if (!compData[0]['release']) {
            fetchCompData();
        }
    }, [comp]);

    const fetchData = async () => {
        setLoad(true);
        setUsrRel(props.usrRel);
        const fetConActivity = await fetchUserVal('fetConActivity', {
            firstVal: props.usrRel,
            secondVal: props.usrRel,
            thirdVal: props.usrRel,
            fourthVal: props.app,
        });

        const fetConAppAct = await fetchJsData({
            type: 'fetch',
            qry: 'fetConAppActDom',
            firstVal: props.app,
            secondVal: props.usrRel,
            thirdVal: props.usrRel,
            fourthVal: props.usrRel,
            fifthVal: props.usrRel,
            sixthVal: props.usrRel,
        });

        const fetConAppPrior = await fetchJsData({
            type: 'fetch',
            qry: 'fetConAppPrior',
            firstVal: props.usrRel,
            secondVal: props.usrRel,
            thirdVal: props.usrRel,
            fourthVal: props.app,
        });

        const fetConAppActDlpSup = await fetchJsData({
            type: 'fetch',
            qry: 'fetConAppActDlpSup',
            firstVal: props.usrRel,
            secondVal: props.usrRel,
            thirdVal: props.usrRel,
            fourthVal: props.app,
        });

        // setRel("snapshot_" + relVersion["version"]);
        setModData({
            conActName: fetConActivity['data'][0]['category_name'],
            conAct: fetConAppAct['data'][1][0]['activityV1'],
            conActDom: fetConAppAct['data'][1][0]['domV1'],
            conAppPrior: fetConAppPrior['data'][0]['activity_name'] ? fetConAppPrior['data'][0]['activity_name'] : '',
            conDlpSup: fetConAppActDlpSup['data'].map((item) => {
                return item.activity_name;
            }),
        });
        setLoad(false);
    };

    const fetchCompData = async () => {
        setLoad(true);
        setUsrRel(props.usrRel);
        if (show) {
            const actData = await fetchJsData({
                type: 'fetch',
                qry: 'fetConAppActs',
                preProcFunc: 'appActInfo',
                preProcess: true,
                firstVal: props.app,
                secondVal: 'snapshot_v' + ppRel + '_0_0',
                thirdVal: 'snapshot_v' + ppRel + '_0_0',
                fourthVal: 'snapshot_v' + ppRel + '_0_0',
                fifthVal: 'snapshot_v' + prevRel + '_0_0',
                sixthVal: 'snapshot_v' + prevRel + '_0_0',
                seventhVal: 'snapshot_v' + prevRel + '_0_0',
                eigthVal: 'snapshot_v' + rel + '_0_0',
                ninthVal: 'snapshot_v' + rel + '_0_0',
                tenthVal: 'snapshot_v' + rel + '_0_0',
            });

            const domData = await fetchJsData({
                type: 'fetch',
                qry: 'fetConDoms',
                preProcFunc: 'appDomInfo',
                preProcess: true,
                firstVal: props.app,
                secondVal: 'snapshot_v' + ppRel + '_0_0',
                thirdVal: 'snapshot_v' + ppRel + '_0_0',
                fourthVal: 'snapshot_v' + prevRel + '_0_0',
                fifthVal: 'snapshot_v' + prevRel + '_0_0',
                sixthVal: 'snapshot_v' + rel + '_0_0',
                seventhVal: 'snapshot_v' + rel + '_0_0',
            });

            const addnData = await fetchJsData({
                type: 'fetch',
                qry: 'fetConAppAddInfo',
                preProcFunc: 'appAddnInfo',
                preProcess: true,
                firstVal: props.app,
                secondVal: 'snapshot_v' + ppRel + '_0_0',
                thirdVal: 'snapshot_v' + ppRel + '_0_0',
                fourthVal: 'snapshot_v' + ppRel + '_0_0',
                fifthVal: 'snapshot_v' + prevRel + '_0_0',
                sixthVal: 'snapshot_v' + prevRel + '_0_0',
                seventhVal: 'snapshot_v' + prevRel + '_0_0',
                eigthVal: 'snapshot_v' + rel + '_0_0',
                ninthVal: 'snapshot_v' + rel + '_0_0',
                tenthVal: 'snapshot_v' + rel + '_0_0',
            });
            setCompData(actData['data']);
            setCompDomData(domData['data']);
            setCompAddnData(addnData['data']);
        }
        setLoad(false);
    };

    const compare = async () => {
        setShowAct1(false);
        setShowAct2(false);
        setShowDom1(false);
        setShowDom2(false);
        setComp(!comp);
    };

    return (
        <>
            <Modal
                // title={app + " > " + modData["conActName"]}
                title={
                    load ? (
                        <div>
                            <Spin size="small" />
                        </div>
                    ) : (
                        <Row gutter={16}>
                            <Col className="gutter-row" span={19}>
                                <Text keyboard>
                                    <>{app + ' > ' + modData['conActName']}</>
                                </Text>
                            </Col>

                            <Col className="gutter-row" span={2}>
                                <Space size="small" align="end">
                                    <Button
                                        type="dashed"
                                        shape="round"
                                        // icon={<OrderedListOutlined />}
                                        onClick={compare}
                                        style={{ backgroundColor: '#f0f5ff' }}
                                        size="small"
                                    >
                                        compare
                                    </Button>
                                    {comp ? (
                                        <Tooltip
                                            title={
                                                <div
                                                    style={{
                                                        fontSize: '9px',
                                                        fontFamily: 'Gill, Helvetica, sans-serif',
                                                    }}
                                                >
                                                    <ul>
                                                        <li>
                                                            <p>
                                                                <Text>No Change</Text>: indicates same as previous release
                                                            </p>
                                                        </li>
                                                        <li>
                                                            <p>
                                                                <Text delete type="danger">
                                                                    Red Text
                                                                </Text>
                                                                : indicates removed in this release
                                                            </p>
                                                            {/* <span style={{ color: "red" }}>Red text</span> */}
                                                        </li>
                                                        <li>
                                                            <p>
                                                                <Text type="success">Green Text</Text>: indicates added in this release
                                                            </p>
                                                        </li>
                                                    </ul>
                                                </div>
                                            }
                                            color="#425162"
                                            // style={{ width: "700px" }}
                                        >
                                            <InfoCircleOutlined />
                                        </Tooltip>
                                    ) : (
                                        <Tooltip
                                            title={
                                                <div
                                                    style={{
                                                        fontSize: '9px',
                                                        fontFamily: 'Gill, Helvetica, sans-serif',
                                                    }}
                                                >
                                                    <ul>
                                                        <li>
                                                            <p>P1 activities are marked in bold</p>
                                                        </li>
                                                        <li>
                                                            <p>
                                                                <b>
                                                                    DLP/TSS supported activities are marked in
                                                                    <Text type="success"> green</Text>
                                                                </b>
                                                            </p>
                                                        </li>
                                                    </ul>
                                                </div>
                                            }
                                            color="#425162"
                                            // style={{ width: "700px" }}
                                        >
                                            <InfoCircleOutlined />
                                        </Tooltip>
                                    )}
                                </Space>
                            </Col>
                        </Row>
                    )
                }
                open={show}
                onOk={closeModal}
                confirmLoading={load}
                onCancel={closeModal}
                width={'50%'}
            >
                <Card className={styles.chart} size="small" headStyle={{ border: 2 }} bordered={true} loading={load}>
                    {comp ? (
                        <>
                            <Card
                                className={styles.chart}
                                title={<Text keyboard> Activity </Text>}
                                size="small"
                                headStyle={{ backgroundColor: '#F0F8FF', border: 1 }}
                                bordered={true}
                                loading={load}
                            >
                                {load ? (
                                    <div>
                                        <Spin size="small" />
                                    </div>
                                ) : (
                                    <>
                                        <Table
                                            rowkey="appAct_id"
                                            size="small"
                                            bordered
                                            className="test"
                                            pagination={false}
                                            dataSource={compData}
                                            columns={[
                                                {
                                                    title: () => {
                                                        return <div style={{ fontSize: '12px' }}>Release </div>;
                                                    },
                                                    dataIndex: 'release',
                                                    key: 'release',
                                                    fixed: 'left',
                                                    width: '10%',
                                                    render: (text) => <span style={{ fontSize: '11px' }}>{text}</span>,
                                                },
                                                {
                                                    title: () => {
                                                        return <div style={{ fontSize: '12px' }}>Activity </div>;
                                                    },
                                                    dataIndex: 'actName',
                                                    key: 'actName',
                                                    fixed: 'left',
                                                    responsive: ['sm'],
                                                    width: '90%',
                                                    render: (text, row) => (
                                                        <>
                                                            {row.id === 1 ? (
                                                                text ? (
                                                                    <span style={{ fontSize: '11px' }}>{text.replaceAll(',', ', ')}</span>
                                                                ) : (
                                                                    text
                                                                )
                                                            ) : row.id === 2 ? (
                                                                <div
                                                                    onClick={() => {
                                                                        setShowAct1(!showAct1);
                                                                    }}
                                                                    style={{ fontSize: '11px' }}
                                                                >
                                                                    {!showAct1 ? (
                                                                        row.actComp === 'No Change' ? (
                                                                            <a>{row.actComp}</a>
                                                                        ) : row.actAdded.length != 0 && row.actRemoved.length != 0 ? (
                                                                            <>
                                                                                <Text type="success">
                                                                                    {row.actAdded.toString().includes("'")
                                                                                        ? row.actAdded.toString().replaceAll(',', ', ')
                                                                                        : row.actAdded.toString()}{' '}
                                                                                </Text>
                                                                                <Text delete type="danger">
                                                                                    {row.actRemoved.toString().includes("'")
                                                                                        ? row.actRemoved.toString().replaceAll(',', ', ')
                                                                                        : row.actRemoved.toString()}
                                                                                </Text>
                                                                            </>
                                                                        ) : row.actAdded.length != 0 ? (
                                                                            <Text type="success">
                                                                                {row.actAdded.toString().includes("'")
                                                                                    ? row.actAdded.toString().replaceAll(',', ', ')
                                                                                    : row.actAdded.toString()}{' '}
                                                                            </Text>
                                                                        ) : (
                                                                            <Text delete type="danger">
                                                                                {row.actRemoved.toString().includes("'")
                                                                                    ? row.actRemoved.toString().replaceAll(',', ', ')
                                                                                    : row.actRemoved.toString()}
                                                                            </Text>
                                                                        )
                                                                    ) : text ? (
                                                                        text.replaceAll(',', ', ')
                                                                    ) : (
                                                                        text
                                                                    )}
                                                                </div>
                                                            ) : (
                                                                <div
                                                                    onClick={() => {
                                                                        setShowAct2(!showAct2);
                                                                    }}
                                                                    style={{ fontSize: '11px' }}
                                                                >
                                                                    {!showAct2 ? (
                                                                        row.actComp === 'No Change' ? (
                                                                            <a>{row.actComp}</a>
                                                                        ) : row.actAdded.length != 0 && row.actRemoved.length != 0 ? (
                                                                            <>
                                                                                <Text type="success">
                                                                                    {row.actAdded.toString().includes("'")
                                                                                        ? row.actAdded.toString().replaceAll(',', ', ')
                                                                                        : row.actAdded.toString()}{' '}
                                                                                </Text>
                                                                                <Text delete type="danger">
                                                                                    {row.actRemoved.toString().includes("'")
                                                                                        ? row.actRemoved.toString().replaceAll(',', ', ')
                                                                                        : row.actRemoved.toString()}
                                                                                </Text>
                                                                            </>
                                                                        ) : row.actAdded.length != 0 ? (
                                                                            <Text type="success">
                                                                                {row.actAdded.toString().includes("'")
                                                                                    ? row.actAdded.toString().replaceAll(',', ', ')
                                                                                    : row.actAdded.toString()}{' '}
                                                                            </Text>
                                                                        ) : (
                                                                            <Text delete type="danger">
                                                                                {row.actRemoved.toString().includes("'")
                                                                                    ? row.actRemoved.toString().replaceAll(',', ', ')
                                                                                    : row.actRemoved.toString()}
                                                                            </Text>
                                                                        )
                                                                    ) : text ? (
                                                                        text.replaceAll(',', ', ')
                                                                    ) : (
                                                                        text
                                                                    )}
                                                                </div>
                                                            )}
                                                        </>
                                                    ),
                                                },
                                            ]}
                                            loading={load}
                                        />
                                    </>
                                )}
                            </Card>

                            <Card
                                className={styles.chart}
                                title={<Text keyboard> Domain </Text>}
                                size="small"
                                headStyle={{ backgroundColor: '#F0F8FF', border: 1 }}
                                bordered={true}
                                loading={load}
                            >
                                {load ? (
                                    <div>
                                        <Spin size="small" />
                                    </div>
                                ) : (
                                    <>
                                        <Table
                                            rowKey="appDom_id"
                                            size="small"
                                            bordered
                                            pagination={false}
                                            dataSource={compDomData}
                                            columns={[
                                                {
                                                    title: () => {
                                                        return <div style={{ fontSize: '12px' }}>Release </div>;
                                                    },
                                                    dataIndex: 'release',
                                                    key: 'release',
                                                    fixed: 'left',
                                                    width: '10%',
                                                    render: (text) => <span style={{ fontSize: '11px' }}>{text}</span>,
                                                },
                                                {
                                                    title: () => {
                                                        return <div style={{ fontSize: '12px' }}>Domain </div>;
                                                    },
                                                    dataIndex: 'domName',
                                                    key: 'domName',
                                                    fixed: 'left',
                                                    responsive: ['sm'],
                                                    width: '90%',
                                                    render: (text, row) => (
                                                        <>
                                                            {row.id === 1 ? (
                                                                text ? (
                                                                    <span style={{ fontSize: '11px' }}>{text.replaceAll(',', ', ')}</span>
                                                                ) : (
                                                                    text
                                                                )
                                                            ) : row.id === 2 ? (
                                                                <div
                                                                    onClick={() => {
                                                                        setShowDom1(!showDom1);
                                                                    }}
                                                                    style={{ fontSize: '11px' }}
                                                                >
                                                                    {!showDom1 ? (
                                                                        row.domComp === 'No Change' ? (
                                                                            <a>{row.domComp}</a>
                                                                        ) : row.domAdded.length != 0 && row.domRemoved.length != 0 ? (
                                                                            <>
                                                                                <Text type="success">
                                                                                    {row.domAdded.toString().includes(',')
                                                                                        ? row.domAdded.toString().replaceAll(',', ', ')
                                                                                        : row.domAdded.toString()}{' '}
                                                                                </Text>{' '}
                                                                                <Text delete type="danger">
                                                                                    {row.domRemoved.toString().includes(',')
                                                                                        ? row.domRemoved.toString().replaceAll(',', ', ')
                                                                                        : row.domRemoved.toString()}{' '}
                                                                                </Text>
                                                                            </>
                                                                        ) : row.domAdded.length != 0 ? (
                                                                            <Text type="success">
                                                                                {row.domAdded.toString().includes(',')
                                                                                    ? row.domAdded.toString().replaceAll(',', ', ')
                                                                                    : row.domAdded.toString()}{' '}
                                                                            </Text>
                                                                        ) : (
                                                                            <Text delete type="danger">
                                                                                {row.domRemoved.toString().includes(',')
                                                                                    ? row.domRemoved.toString().replaceAll(',', ', ')
                                                                                    : row.domRemoved.toString()}{' '}
                                                                            </Text>
                                                                        )
                                                                    ) : text ? (
                                                                        text.replaceAll(',', ', ')
                                                                    ) : (
                                                                        text
                                                                    )}
                                                                </div>
                                                            ) : (
                                                                <div
                                                                    onClick={() => {
                                                                        setShowDom2(!showDom2);
                                                                    }}
                                                                    style={{ fontSize: '11px' }}
                                                                >
                                                                    {!showDom2 ? (
                                                                        row.domComp === 'No Change' ? (
                                                                            <a>{row.domComp}</a>
                                                                        ) : row.domAdded.length != 0 && row.domRemoved.length != 0 ? (
                                                                            <>
                                                                                <Text type="success">
                                                                                    {row.domAdded.toString().includes(',')
                                                                                        ? row.domAdded.toString().replaceAll(',', ', ')
                                                                                        : row.domAdded.toString()}{' '}
                                                                                </Text>{' '}
                                                                                <Text delete type="danger">
                                                                                    {row.domRemoved.toString().includes(',')
                                                                                        ? row.domRemoved.toString().replaceAll(',', ', ')
                                                                                        : row.domRemoved.toString()}{' '}
                                                                                </Text>
                                                                            </>
                                                                        ) : row.domAdded.length != 0 ? (
                                                                            <Text type="success">
                                                                                {row.domAdded.toString().includes(',')
                                                                                    ? row.domAdded.toString().replaceAll(',', ', ')
                                                                                    : row.domAdded.toString()}{' '}
                                                                            </Text>
                                                                        ) : (
                                                                            <Text delete type="danger">
                                                                                {row.domRemoved.toString().includes(',')
                                                                                    ? row.domRemoved.toString().replaceAll(',', ', ')
                                                                                    : row.domRemoved.toString()}{' '}
                                                                            </Text>
                                                                        )
                                                                    ) : text ? (
                                                                        text.replaceAll(',', ', ')
                                                                    ) : (
                                                                        text
                                                                    )}
                                                                </div>
                                                            )}
                                                        </>
                                                    ),
                                                },
                                            ]}
                                            loading={load}
                                        />
                                    </>
                                )}
                            </Card>

                            <Card
                                className={styles.chart}
                                title={<Text keyboard> Additional App Data </Text>}
                                size="small"
                                headStyle={{ backgroundColor: '#F0F8FF', border: 1 }}
                                bordered={true}
                                loading={load}
                            >
                                {load ? (
                                    <div>
                                        <Spin size="small" />
                                    </div>
                                ) : (
                                    <>
                                        <Table
                                            rowKey="appAddn_id"
                                            size="small"
                                            bordered
                                            pagination={false}
                                            dataSource={compAddnData}
                                            columns={[
                                                {
                                                    title: () => {
                                                        return <div style={{ fontSize: '12px' }}>Release </div>;
                                                    },
                                                    dataIndex: 'release',
                                                    key: 'release',
                                                    fixed: 'left',
                                                    width: '10%',
                                                    render: (text) => <span style={{ fontSize: '11px' }}>{text}</span>,
                                                },
                                                {
                                                    title: () => {
                                                        return <div style={{ fontSize: '12px' }}>Priority </div>;
                                                    },
                                                    dataIndex: 'priority',
                                                    key: 'priority',
                                                    fixed: 'left',
                                                    width: '10%',
                                                    render: (text) => <span style={{ fontSize: '11px' }}>{text}</span>,
                                                },
                                                {
                                                    title: () => {
                                                        return <div style={{ fontSize: '12px' }}>Instance Support </div>;
                                                    },
                                                    dataIndex: 'ins_support',
                                                    key: 'ins_support',
                                                    fixed: 'left',
                                                    width: '15%',
                                                    render: (text) => <span style={{ fontSize: '11px' }}>{text}</span>,
                                                },
                                                {
                                                    title: () => {
                                                        return <div style={{ fontSize: '12px' }}>Synthetic Support </div>;
                                                    },
                                                    dataIndex: 'syn_support',
                                                    key: 'syn_support',
                                                    fixed: 'left',
                                                    width: '15%',
                                                    render: (text) => <span style={{ fontSize: '11px' }}>{text}</span>,
                                                },
                                                {
                                                    title: () => {
                                                        return <div style={{ fontSize: '12px' }}>dlp </div>;
                                                    },
                                                    dataIndex: 'dlp',
                                                    key: 'dlp',
                                                    fixed: 'left',
                                                    width: '5%',
                                                    render: (text) => <span style={{ fontSize: '11px' }}>{text}</span>,
                                                },
                                                {
                                                    title: () => {
                                                        return <div style={{ fontSize: '12px' }}>tss </div>;
                                                    },
                                                    dataIndex: 'tss',
                                                    key: 'tss',
                                                    fixed: 'left',
                                                    width: '5%',
                                                    render: (text) => <span style={{ fontSize: '11px' }}>{text}</span>,
                                                },
                                            ]}
                                            loading={load}
                                        />
                                    </>
                                )}
                            </Card>
                        </>
                    ) : (
                        <>
                            <Card
                                className={styles.chart}
                                title={<Text keyboard> Activity </Text>}
                                size="small"
                                headStyle={{ backgroundColor: '#F0F8FF', border: 1 }}
                                bordered={true}
                                loading={load}
                            >
                                <div style={{ fontSize: '12px' }}>
                                    {
                                        <>
                                            {modData['conAct'].split(',').map(function (item, i) {
                                                return (
                                                    <a
                                                        key={'own' + i}
                                                        className={styles.clickablelink}
                                                        onClick={() => {
                                                            setActActionModal(true);
                                                            setSelAct(item);
                                                            setShow(false);
                                                        }}
                                                    >
                                                        {modData['conAppPrior'].split(',|').includes(item) ? (
                                                            <b
                                                                style={{
                                                                    color: modData['conDlpSup'].includes(item) ? 'green' : 'black',
                                                                }}
                                                            >
                                                                {item}
                                                            </b>
                                                        ) : (
                                                            <span
                                                                style={{
                                                                    color: modData['conDlpSup'].includes(item) ? 'green' : 'black',
                                                                }}
                                                            >
                                                                {item}
                                                            </span>
                                                        )}
                                                        {modData['conAct'].split(',').length - 1 === i ? '' : ', '}
                                                    </a>
                                                );
                                            })}
                                        </>
                                    }
                                </div>
                            </Card>

                            <Card
                                className={styles.chart}
                                title={<Text keyboard> Domain </Text>}
                                size="small"
                                headStyle={{ backgroundColor: '#F0F8FF', border: 1 }}
                                bordered={true}
                                loading={load}
                            >
                                <Text style={{ fontSize: '12px' }}>
                                    {modData['conActDom'] ? modData['conActDom'].replaceAll(',', ', ') : modData['conActDom']}
                                </Text>
                            </Card>
                        </>
                    )}
                </Card>
            </Modal>
            {selAct != '' ? (
                <ActActionModal
                    usrRel={props.usrRel}
                    rel={props.rel}
                    modalTitle={selAct}
                    appEntData={props.appEntData}
                    app={app}
                    actActionModal={actActionModal}
                    parentModal={setActActionModal}
                    parentShow={setShow}
                    parentSelAct={setSelAct}
                />
            ) : null}
        </>
    );
};

const ActActionModal = (props) => {
    const [modalTitle, setModalTitle] = useState(props.modalTitle);
    const [loading, setLoading] = useState(true);
    const [origData, setOrigData] = useState({
        appActAction: [],
        fetConAppActConstraint: [],
    });
    const [show, setShow] = useState(false);

    const ColActAction = [
        {
            title: 'Profile',
            dataIndex: 'profile',
            key: 'profile',
            fixed: 'left',
            width: '10%',
        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
        },
    ];

    const ColSupConstraints = [
        {
            title: 'Supported Constraints',
            dataIndex: 'var_name',
            key: 'var_name',
            fixed: 'var_name',
            render: (text, record) => {
                const rec =
                    record && record.var_name
                        ? record.var_name.includes(',')
                            ? record.var_name.split(',')
                            : record.var_name
                            ? [record.var_name]
                            : []
                        : [];

                const fSize = record.file_size === 1 ? rec.push('File Size') : rec;
                const fType = record.file_type === 1 ? rec.push('File Type') : rec;
                rec.sort((a, b) => (a ? a.localeCompare(b) : 1));

                return (
                    <span>
                        {Array.isArray(rec)
                            ? rec
                                  .map((x) =>
                                      x.includes('_')
                                          ? x.split('_')[0].charAt(0).toUpperCase() +
                                            x.split('_')[0].slice(1) +
                                            ' ' +
                                            x.split('_')[1].charAt(0).toUpperCase() +
                                            x.split('_')[1].slice(1)
                                          : x
                                  )
                                  .join(', ')
                            : rec}
                    </span>
                );
            },
        },
    ];

    const openModal = () => setShow(props.actActionModal);
    const closeModal = () => {
        setShow(false);
        props.parentSelAct('');
    };
    const backModal = () => {
        setShow(false);
        props.parentShow(true);
        props.parentSelAct('');
    };

    useEffect(() => {
        setLoading(true);
        const fetchActAction = async () => {
            const { data: appActAction } = await fetchJsData({
                type: 'fetch',
                qry: 'fetConAppActAction',
                preProcess: true,
                preProcFunc: 'appActConAction',
                firstVal: props.usrRel,
                secondVal: props.usrRel,
                thirdVal: props.usrRel,
                fourthVal: props.usrRel,
                fifthVal: props.app,
                sixthVal: props.modalTitle,
            });

            const { data: fetConAppActConstraint } = await fetchJsData({
                type: 'fetch',
                qry: 'fetConAppActConstraint',
                firstVal: props.usrRel,
                secondVal: props.usrRel,
                thirdVal: props.appEntData.appId,
                fourthVal: props.usrRel,
                fifthVal: props.modalTitle,
            });
            setOrigData({
                appActAction: appActAction.appActAction,
                fetConAppActConstraint: fetConAppActConstraint,
            });
            // setOrigData(appActAction.appActAction);
            if (appActAction.appActAction && fetConAppActConstraint) setLoading(false);
        };
        if (props.actActionModal === true) {
            fetchActAction();
        }
    }, [modalTitle]);

    useEffect(() => {
        if (props.modalTitle != '') {
            setModalTitle(props.modalTitle);
            if (props.actActionModal === true) {
                openModal();
            }
        }
    }, [props.modalTitle]);

    return (
        <Modal
            title={
                loading ? (
                    <div>
                        <Spin size="small" />
                    </div>
                ) : (
                    <>
                        <ArrowLeftOutlined
                            onClick={() => {
                                backModal();
                            }}
                        />
                        <Text keyboard>
                            {props.app} {'-> '} {modalTitle}
                        </Text>
                    </>
                )
            }
            visible={show}
            onOk={closeModal}
            confirmLoading={loading}
            onCancel={closeModal}
            width="50%"
            destroyOnClose={true}
        >
            <>
                <Card size="small" bordered={true} loading={loading}>
                    <Table
                        rowKey="file_size"
                        size="small"
                        bordered
                        columns={ColSupConstraints}
                        loading={loading}
                        dataSource={origData.fetConAppActConstraint}
                        pagination={false}
                    />
                </Card>
                <br />
                <Card size="small" bordered={true} loading={loading}>
                    <Table
                        rowKey="profile"
                        size="small"
                        bordered
                        columns={ColActAction}
                        loading={loading}
                        dataSource={origData.appActAction}
                        pagination={false}
                    />
                </Card>
            </>
        </Modal>
    );
};
